import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {LocationVm} from 'src/app/view-model/location/location.vm';
import {debounceTime, distinctUntilKeyChanged, finalize, first, map, tap} from 'rxjs/operators';
import {timer} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {UpdateDeliveryTypeEvent} from '../../../event-listeners/update-delivery-type/update-delivery-type.event';
import {SessionEvent} from '../../../event-listeners/session/session.event';
import {DeliveryTypeEnum} from '../../../../../data/networking/models/location/enum/delivery-type.enum';
import {ToggleMenuREvent} from '../../../event-listeners/toggle-menu-r/toggle-menu-r.event';
import {PageEvent} from '../../../event-listeners/event-page/event-page.event';
import {countryConfig} from '../../../../../../country-config/country-config';
import {ModalsEvent} from '../../../event-listeners/modals/modals.event';

@Component({
  selector: 'app-delivery-type',
  templateUrl: './delivery-type.component.html',
  styleUrls: ['./delivery-type.component.scss'],
})
export class DeliveryTypeComponent implements OnInit {
  toggleShowR = false;
  @Input() sasCart;
  @Input() configModule;
  @Output() openSasConfirmation = new EventEmitter();
  @Output() public changeDeliveryExt = new EventEmitter();
  @Input() icon;

  countryConfig = countryConfig;
  currentCity;
  previousCity;
  nameCity = countryConfig.defaultNameCity;
  deliveryTime = {
    EXPRESS: '',
    NATIONAL: '',
    ENVIALOYA: '',
  };
  deliveryTypes = countryConfig.generalEnv.deliveryTypes;
  arrayCities = [];
  cityDefault = 'Bogota';
  previousDelivery = '';
  public christmas: boolean = countryConfig.christmas;

  constructor(private vm: LocationVm,
              private deliveryTypeEvent: UpdateDeliveryTypeEvent,
              private toggleMenuR: ToggleMenuREvent,
              private sessionEvent: SessionEvent,
              private eventPage: PageEvent,
              private route: ActivatedRoute,
              private modalsEvent: ModalsEvent) {
                this.route.queryParams.subscribe(res => {
                  this.cityDefault = res.ciudad;
                });
              }

  changeCity(city) {
    
    if (this.previousDelivery === 'EXPRESS' && city.deliveryType === 'NATIONAL') {
      this.modalsEvent.changeModalImgTextSimple({open: true});
    }
    
    this.previousDelivery = city.deliveryType;

    if (city) {
      if (!city.force && city.deliveryType === DeliveryTypeEnum.ENVIALOYA
        && this.sasCart && this.sasCart.amountCart > 0) {
        this.openSasConfirmation.emit({open: true, type: 'city', location: city});
        return;
      }

      timer(100)
        .pipe(
          first(),
          debounceTime(100),
          )
        .subscribe(async() => {
          this.vm.changeContextLng(city?.name);
          this.vm.setCity(city, false);

          await this.vm.setNearbyStores();

          if (!this.previousCity || this.previousCity.defaultStore !== city.defaultStore) {
            this.deliveryTypeEvent.changeDeliveryType(city);
            this.previousCity = city;
            this.vm.getDeliveryTypeTimeFromService();
          }
        });
      this.nameCity = city.name || this.vm.getNameMainCity();

      this.toggleShowR = false;
      this.changeDeliveryExt.emit(this.nameCity);
    }
  }

  toggleDeliveryTimeR() {
    this.toggleShowR = false;
  }

  getCity() {
    this.vm.getCity()
      .pipe(
        finalize(() => this.getCities()),
      )
      .subscribe(city => {
        if (city && city.name) {
          this.changeCity(city);
          this.currentCity = city;
        }
      });
  }

  getCities() {
    this.sessionEvent.hasCustomer
      .subscribe(response => {
        if (response.customer == null) {
          this.vm.getCities(DeliveryTypeEnum.EXPRESS)
            .pipe(tap(cities => {
              this.arrayCities = cities;
              this.validateCityUrl();
              if (!this.currentCity) {
                const city = cities.filter(i => i.id === this.deliveryTypes.express.id)[0];
                if (!this.nameCity) { this.changeCity(city); }
              }
            }))
            .subscribe();

          this.vm.getDeliveryTypeText().pipe(debounceTime(500))
            .subscribe(res => {
              this.deliveryTime = res.deliveryTimeLabelGeneric;
            });
        }
      });
  }

  ngOnInit() {
    this.eventPage.eventCallAllComponentsListener.subscribe((res: any) => {
      if (res.allComponents) {
        this.callAllComponents();
      }
    });
  }

  callAllComponents() {
    this.getCity();
    this.deliveryTypeEvent.currentDeliveryType
    .pipe(
      debounceTime(500),
      map(v => (!v ? {defaultStore: undefined} : v)),
      distinctUntilKeyChanged('defaultStore'),
    )
    .subscribe(city => {
      this.changeCity(city);
    });

    this.toggleMenuR.currentDisplay.subscribe(option => {
      this.toggleShowR = option.show;
    });
  }

  validateCityUrl() {
    let aux;
    if (this.cityDefault) {
      aux = this.cityDefault.split(' ').join().toLowerCase();
    }
    this.arrayCities.forEach(res => {
      if (res.geoCityCode.split(' ').join().toLowerCase() === aux) {
        this.changeCity(res);
      }
    });
  }
}
